import { BURBANK_GEOID_NUMERIC } from './bwpObservations';

/**
 * Municipal utilities (BWP, GWP, etc.) use EIA-861 **nonresidential** retail sales
 * (commercial + industrial + other non-res sectors when reported), not IOU-style commercial-only.
 * IOU cities keep the legacy commercial sector label until handled separately.
 */
const MUNICIPAL_NONRESIDENTIAL_ELECTRICITY_GEOFIPS = new Set<number>([
  BURBANK_GEOID_NUMERIC,
  630_000, // Glendale (GWP)
]);

export const MUNICIPAL_ELECTRICITY_NONRESIDENTIAL_LABEL = 'Nonresidential';

export function normalizeGeofipsNumeric(geofips: number | string): number {
  return Number(String(geofips).replace(/^0+/, '') || '0');
}

export function usesMunicipalNonresidentialElectricity(
  geofips: number | string | null | undefined
): boolean {
  if (geofips == null) return false;
  return MUNICIPAL_NONRESIDENTIAL_ELECTRICITY_GEOFIPS.has(normalizeGeofipsNumeric(geofips));
}

export function electricitySectorLabelForGeofips(
  geofips: number | string | null | undefined,
  fuel: 'electricity' | 'natural_gas' = 'electricity'
): 'Commercial' | 'Nonresidential' {
  if (fuel !== 'electricity') return 'Commercial';
  return usesMunicipalNonresidentialElectricity(geofips)
    ? MUNICIPAL_ELECTRICITY_NONRESIDENTIAL_LABEL
    : 'Commercial';
}

/** GHG inventory stacked-bar category label (electricity non-IOU sector). */
export function ghgElectricityNonresidentialCategoryLabel(
  geofips: number | string | null | undefined
): string {
  return `Electricity ${electricitySectorLabelForGeofips(geofips)}`;
}
